"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var MLB = function MLB(props) {
  var size = props.size;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: size,
    height: size,
    preserveAspectRatio: "xMidYMid slice",
    clipRule: "evenodd",
    fillRule: "evenodd",
    viewBox: "0 0 560 400",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "m430.041 102.961h-300.025c-7.951-.025-15.598 3.086-21.274 8.656-5.666 5.676-8.817 13.396-8.739 21.415v133.882c-.088 7.991 3.055 15.686 8.712 21.331 5.647 5.645 13.317 8.813 21.301 8.796h300.025c16.47-.078 29.974-13.656 29.959-30.127v-134.135c0-16.271-13.319-29.693-29.592-29.816h-.367z",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m449.462 133.004c.124-10.576-8.477-19.379-19.051-19.502l-.369-.002h-83.859l48.113 80.404 4.441.562 2.81 3.68v3.43l3.036.616 2.81 3.822v3.317l3.147.562 3.175 3.456v7.645c3.783 3.414 8.043 6.255 12.648 8.431 4.244 1.629 4.72 8.431 7.278 12.057 3.204 5.282 7.588 7.391 6.662 10.341-2.137 7.897-10.23 21.217-17.762 21.836h-29.789v12.759h37.321c10.7-.046 19.465-8.888 19.42-19.588l-.002-.084v-133.742",
    fill: "#bf0d3e"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m244.309 273.856h-14.415c0-36.029 12.168-55.953 26.753-59.916 1.996-.365 1.04-10.201-1.489-13.208h-8.431c-1.348 0-.562-2.531-.562-2.531l6.829-14.585-.929-3.99h-25.235l20.739-14.501c.956-38.248 40.187-41.227 63.822-25.291 14.051 9.301 15.12 27.736 14.051 40.468-.168.814-3.653.281-3.653.281s-2.388 14.051 3.85 14.051h27.569c11.241-.449 22.09 7.167 22.09 7.167l2.642-9.639-60.394-78.661h-187.531c-5.185-.029-10.178 1.992-13.883 5.621-3.648 3.692-5.672 8.693-5.621 13.883v133.909c-.065 5.177 1.963 10.165 5.621 13.826 3.682 3.682 8.677 5.756 13.883 5.762h121.742c-2.98-5.114-6.378-10.933-7.418-12.646",
    fill: "#041e42"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m137.547 245.442c0-7.307 6.014-13.319 13.321-13.319s13.321 6.014 13.321 13.321-6.014 13.321-13.321 13.321l-.113-.002h-.027c-7.221 0-13.166-5.932-13.18-13.151v-.17",
    fill: "#fff"
  }));
};

MLB.propTypes = {
  size: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
};
MLB.defaultProps = {
  size: '100'
};
var _default = MLB;
exports["default"] = _default;